<template>
    <div>
        <Panel
            v-if="!accessPoint"
            :title="$t('Manage Number Groups')"
            :add-button="$store.hasRight('ADD_NUMBER_GROUPS') ? $t('Add') : ''"
            :delete-button="selected.length > 0"
            :help-text="$t('DESC_NUMBER_GROUPS')"
            @delete="handleDelete"
            @input="openForm(-1)"
        >
            <table id="accesspointgroups_table" class="cic-table">
                <thead>
                    <tr>
                        <th>{{ $t('Group Name') }}</th>
                        <th>{{ $t('Group Description') }}</th>
                        <th>{{ $t('Group Members') }}</th>
                        <th v-if="$store.hasRight('DELETE_NUMBER_GROUPS')" class="td-checkbox"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="group in items" @click="(evt) => handleOpen(group.accessId, evt)">
                        <td class="primary">
                            {{ group.name }}
                        </td>
                        <td>{{ group.description }}</td>
                        <td>{{ group.memberCount }}</td>
                        <td v-if="$store.hasRight('DELETE_NUMBER_GROUPS')">
                            <cic-checkbox
                                :value="selected.indexOf(group.accessId) !== -1"
                                @click="handleSelected(group.accessId)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </Panel>

        <EditAccessPointGroup
            v-if="item !== null && !$store.showLoadingOverlay"
            :item="item"
            @blur="closePopup"
            @input="saveItem"
            @change="updateFieldValue"
        />

        <div v-if="$store.showLoadingOverlay" class="cic-overlay"></div>
    </div>
</template>

<script>
    import Panel from '@/components/container/Panel';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import TableUtils from '@/mixins/TableUtils';
    import EditAccessPointGroup from './EditAccessPointGroup';
    import { deleteItems, load, save } from '@/utils/Http';
    import './styles/accesspointgroups.scss';

    export default {
        name: 'AccessPointGroups',
        components: {
            Panel,
            EditAccessPointGroup,
            CicCheckbox,
        },
        mixins: [TableUtils],
        props: {
            accessPoint: {
                type: Object,
                default: () => null,
            },
        },
        emits: ['blur', 'change'],
        data() {
            return {
                item: null,
                items: [],
                orgId: null,
                selected: [],
            };
        },
        created() {
            this.orgId = this.accessPoint ? this.accessPoint.orgId : null;
            if (this.accessPoint) {
                this.openForm(this.accessPoint.groupId);
            } else {
                this.loadTable();
            }
        },
        methods: {
            closePopup() {
                this.item = null;
                this.$emit('blur');
            },

            handleDelete() {
                deleteItems('accesspointgroups/delete', { accessIds: this.selected }, () => {
                    this.loadTable();
                });
            },

            loadTable() {
                this.item = null;
                this.selected = [];
                load('accesspointgroups/get', {}, (response) => {
                    this.items = response.groups;
                });
            },

            openForm(accessId) {
                load('accesspointgroup/get', { orgId: this.orgId, accessId }, (response) => {
                    this.item = response.group;
                });
            },

            saveItem() {
                if (this.item.name.trim() === '') {
                    alert(this.$t('Group Name is a required field'));
                    return;
                }

                save(
                    'accesspointgroup/update',
                    {
                        accessId: this.item.accessId,
                        orgId: this.orgId,
                        name: this.item.name,
                        description: this.item.description,
                        members: JSON.stringify(this.item.members),
                    },
                    () => {
                        if (this.accessPoint) {
                            this.item = null;
                            this.$emit('change');
                        } else {
                            this.loadTable();
                        }
                    },
                );
            },
        },
    };
</script>
